import { gql } from 'graphql.macro';

export const createMaterialTemplate = gql`
    mutation createMaterial(
        $materialCode: String!
        $description: String!
        $vat: Float!
        $batchInventoryManagement: Boolean!
        $batches: [MaterialBatchInput]
    ) {
        createMaterial(
            materialCode: $materialCode
            description: $description
            vat: $vat
            batchInventoryManagement: $batchInventoryManagement
            batches: $batches
        ) {
            _id
            materialCode
            description
            vat
            addedDate
        }
    }
`;

export const modifyMaterialTemplate = gql`
    mutation modifyMaterial(
        $_id: String!
        $materialCode: String!
        $description: String!
        $vat: Float!
        $batchInventoryManagement: Boolean
        $batches: [MaterialBatchInput]
        $inactive: Boolean
    ) {
        modifyMaterial(
            _id: $_id
            materialCode: $materialCode
            description: $description
            vat: $vat
            batchInventoryManagement: $batchInventoryManagement
            batches: $batches
            inactive: $inactive
        ) {
            _id
            materialCode
            description
            vat
            addedDate
            inactive
            inactivatedDate
            batchInventoryManagement
            batches {
                batchNumber
                quantity
                fullBatchQuantity
                createdOn
                closed
                closedDate
            }
        }
    }
`;

export const createMaterialPriceListTemplate = gql`
    mutation createMaterialPriceList(
        $materialPriceListName: String!
        $currency: String!
        $materialListType: MaterialListType!
        $conversionRate: Float
    ) {
        createMaterialPriceList(
            materialPriceListName: $materialPriceListName
            currency: $currency
            materialListType: $materialListType
            conversionRate: $conversionRate
        ) {
            _id
            materialPriceListName
            currency
            materialListType
            conversionRate
            conversionCurrency
            isStandardPriceList
            materials {
                _id
                material
                materialCode
                description
                basePrice
                originalPrice
            }
        }
    }
`;

export const modifyMaterialPriceListTemplate = gql`
    mutation modifyMaterialPriceList($_id: String!, $materialPriceListName: String!, $conversionRate: Float) {
        modifyMaterialPriceList(
            _id: $_id
            materialPriceListName: $materialPriceListName
            conversionRate: $conversionRate
        ) {
            _id
            materialPriceListName
            currency
            materialListType
            conversionRate
            conversionCurrency
            isStandardPriceList
            materials {
                _id
                material
                materialCode
                description
                addedDate
                basePrice
                originalPrice
            }
        }
    }
`;

export const deleteMaterialPriceListTemplate = gql`
    mutation deleteMaterialPriceList($priceListId: String!) {
        deleteMaterialPriceList(priceListId: $priceListId)
    }
`;

export const addDefaultMaterialPriceListTemplate = gql`
    mutation addDefaultMaterialPriceList($priceListId: String!) {
        addDefaultMaterialPriceList(priceListId: $priceListId) {
            _id
            materialPriceListName
            currency
            materialListType
            conversionRate
            conversionCurrency
            isStandardPriceList
            materials {
                _id
                material
                materialCode
                description
                addedDate
                basePrice
                originalPrice
            }
        }
    }
`;

export const addMaterialToPriceListTemplate = gql`
    mutation addMaterialToPriceList($priceListId: String!, $materialId: String!, $basePrice: Float!) {
        addMaterialToPriceList(priceListId: $priceListId, materialId: $materialId, basePrice: $basePrice) {
            _id
            materialPriceListName
            currency
            isStandardPriceList
            materialListType
            conversionRate
            conversionCurrency
            materials {
                _id
                material
                materialCode
                description
                basePrice
                originalPrice
            }
        }
    }
`;

export const editMaterialPriceListRowTemplate = gql`
    mutation editMaterialPriceListRow($priceListId: String!, $materialId: String!, $basePrice: Float!) {
        editMaterialPriceListRow(priceListId: $priceListId, materialId: $materialId, basePrice: $basePrice) {
            _id
            materialPriceListName
            currency
            isStandardPriceList
            materialListType
            conversionRate
            conversionCurrency
            materials {
                _id
                material
                materialCode
                description
                basePrice
                originalPrice
            }
        }
    }
`;

export const deleteMaterialPriceListRowTemplate = gql`
    mutation deleteMaterialPriceListRow($priceListId: String!, $materialId: String!) {
        deleteMaterialPriceListRow(priceListId: $priceListId, materialId: $materialId) {
            _id
            materialPriceListName
            currency
            isStandardPriceList
            materialListType
            conversionRate
            conversionCurrency
            materials {
                _id
                material
                materialCode
                description
                basePrice
                originalPrice
            }
        }
    }
`;

export const materialBatchManagementTemplate = gql`
    mutation materialBatchManagement($materialCode: String!, $batches: [MaterialBatchInput]) {
        materialBatchManagement(materialCode: $materialCode, batches: $batches) {
            _id
            batches {
                batchNumber
                quantity
                fullBatchQuantity
                createdOn
                closed
                closedDate
            }
        }
    }
`;
